import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { installAppShellFreshnessGuard } from "@/lib/appShellFreshness";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// iOS and other mobile browsers can restore a suspended tab with the exact
// React bundle that was loaded before a deployment. Revalidate the entry-bundle
// fingerprint whenever the tab becomes active and refresh only if production
// has actually moved to a newer build.
installAppShellFreshnessGuard();
